function PlacesTab({ places, onAdd, onEdit, onDelete }) {
    return (
        <div className="admin__section">
            <button className="admin__add-btn" onClick={onAdd}>
                + Adaugă loc
            </button>
            <table className="admin__table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nume</th>
                        <th>Acțiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {places.map((p) => (
                        <tr key={p.id}>
                            <td>{p.id}</td>
                            <td>{p.name}</td>
                            <td>
                                <button onClick={() => onEdit(p)}>Editează</button>
                                <button onClick={() => onDelete(p.id)} className="delete">
                                    Șterge
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default PlacesTab;
